<template>
  <div class="outdoorsLine" id="outdoorsLine">
    <div class="container">
      <div class="title-top">
        <div class="title">
          <div class="one">{{message.styleTitle}}</div>
          <div class="describe">{{message.styleDescribe}}</div>
        </div>
        <div class="button-right" @click="toMore">
          <span>
            更多
            <i class="fa fa-plus" aria-hidden="true"></i>
          </span>
        </div>
      </div>
      <div class="content">
        <div
          class="rotation-left"
          v-for="(item,index) in message.linePageList['0'].linePage"
          :key="index"
          @click="toDetail(item.id)"
        >
          <div class="trans-img">
            <img :src="item.linePictureUrl" class="left-img" />
          </div>
          <div class="basic-information">
            <div class="label-text">{{item.lineTitile}}</div>
            <div class="info-bottom">
              <div class="price">{{ item.price ? `￥${item.price}` : '价格待定' }}</div>
              <div>
                <span>
                  <i class="fa fa-clock-o" aria-hidden="true"></i>
                  {{fomateDate(item.date)}}
                </span>
                <span class="weeek" :class="colorClass(item.signUpStatus)">{{item.signUpStatus}}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="between-after" v-for="(item,index) in afterLength"></div>
        
      </div>
    </div>
  </div>
  <!-- aboutUs end -->
</template>

<script>
import axios from "axios";
import { fomateDate } from "@/util/util";

export default {
  name: "outdoorsLine",
  data() {
    return {};
  },
  props: {
    message: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  components: {},
  computed: {
    nav() {
      return this.$route.params.id;
    },
    basicInfo() {
      return this.$store.state.webInfo;
    },
    afterLength(){
      const num = this.message.linePageList['0'].linePage.length % 3;
      return num === 2 ? 1 : 0;
    },
    colorClass(status){
      return function(status){
        switch (status) {
          case '报名中':
            return 'green'
            break;
          case '已成行':
            return 'orange'
            break;
          case '已满员':
            return 'red'
            break;
        }
      }
    }
  },
  mounted() {},
  methods: {
    fomateDate,
    toDetail(id) {
      this.$router.push({
        path: "/activityDetail",
        query: { id: id }
      });
    },
    // toMore(){
    //   this.$router.push({ path: `/introductionList` });
    // },
    toMore() {
      this.$router.push({
        path: `/searchActivity`,
        query: {
          id: this.message.styleId,
          title: this.message.styleTitle
        }
      });
    }
  }
};
</script>

<style scoped>
.container {
  position: relative;
  background: #fff;
  text-align: left;
}
.title-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
/* 小标题 */
.title {
  margin: 20px 0;
}
.one {
  color: #007741;
  font-weight: bold;
  height: 30px;
  font-size: 16px;
}
.describe {
  border-top: 1px solid #cccccc;
  padding: 10px 0;
  color: #676767;
  font-size: 14px;
  width: 300px;
}
.button-right {
  width: 80px;
  height: 36px;
  font-size: 14px;
  line-height: 36px;
  text-align: center;
  border: 1px solid #cccccc;
  border-radius: 8px;
  cursor: pointer;
}
.content {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-bottom: 20px;
}
.rotation-left {
  cursor: pointer;
  position: relative;
  width: 31%;
  /* height: 300px; */
  margin-bottom: 20px;
  /* background: #999; */
  background: #faf7f7;
  box-shadow: 0px 0px 10px #aaaaaa;
}
.between-after {
  position: relative;
  width: 31%;
  margin-bottom: 20px;
}
/* .rotation-left:hover {
  box-shadow: 0px 0px 10px #aaaaaa;
} */
.rotation-left:hover .left-img{
   transform: scale(1.2);
}
.trans-img {
  width: 100%;
  height: 200px;
  overflow: hidden;
}
.left-img {
  width: 100%;
  height: 100%;
  transition: all 0.6s;
}
/* .left-img:hover {
  transform: scale(1.2);
} */

.basic-information {
  /* position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 10; */
  /* color: #fff; */
  font-weight: bold;
  padding: 10px 0;
  margin: 8px 12px;
  /* background: rgba(0, 0, 0, 0.4); */
}
.label {
  padding: 6px 12px;
  font-size: 13px;
  background: rgba(0, 0, 0, 0.8);
  line-height: 40px;
}
.label-text {
  height: 40px;
  line-height: 40px;
  /* border-bottom: 1px solid #ffffff; */
  margin-bottom: 10px;
  width: 100%;
  overflow: hidden;
  word-break: keep-all; /* 不换行 */
  white-space: nowrap; /* 不换行 */
  text-overflow: ellipsis;
}
.info-bottom {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 13px;
}
.info-bottom .price {
  color: #ff6c00;
  font-size: 22px;
}
.right-infobottom {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 13px;
  position: absolute;
  bottom: 10px;
  left: 0;
  right: 0;
}
.weeek {
  display: inline-block;
  margin-left: 20px;
  background: #007640;
  color: #fff;
  font-size: 14px;
  padding: 4px 12px;
  border-radius: 12px;
  cursor: pointer;
}
.green {
  background: #007640;
}
.orange {
  background: #ff6c00;
}
.red {
  background: rgb(211, 23, 23);
}
</style>



// WEBPACK FOOTER //
// src/components/home/outdoorsLine.vue